module.exports = __webpack_public_path__ + "static/media/xira-L-W-A-360.bff2a43c.gif";